import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteProductServiceInfoApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-product-service-info'
  }

  
  /**
       * 根据id 逻辑删除
       * @param idParam 分类id 
       * @returns 
       */
  public delVerifyById(idParam) {
 
    return this.send({id:idParam}, "delVerifyById", this.Methods.GET)
  }

  // 保存
  public saveRemark(params){
    return this.send(params,"saveRemark",Methods.POST)
  }

  public getEntityById(id){
    return this.send({id:id},"getEntityById",Methods.GET)
  }

  public updateApproveState(params){
    return this.send(params,"updateApproveState",Methods.POST)
  }


}